import { render, staticRenderFns } from "./commerces.vue?vue&type=template&id=4098d219&scoped=true&"
import script from "./commerces.vue?vue&type=script&lang=ts&"
export * from "./commerces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098d219",
  null
  
)

export default component.exports